var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97849 23.7419C1.97849 23.7419 0 23.7419 0 21.7634C0 19.7849 1.97849 13.8495 11.871 13.8495C21.7634 13.8495 23.7419 19.7849 23.7419 21.7634C23.7419 23.7419 21.7634 23.7419 21.7634 23.7419H1.97849ZM11.871 11.871C13.4452 11.871 14.9549 11.2456 16.068 10.1325C17.1811 9.01939 17.8065 7.50967 17.8065 5.93548C17.8065 4.3613 17.1811 2.85158 16.068 1.73846C14.9549 0.625344 13.4452 0 11.871 0C10.2968 0 8.78707 0.625344 7.67395 1.73846C6.56083 2.85158 5.93548 4.3613 5.93548 5.93548C5.93548 7.50967 6.56083 9.01939 7.67395 10.1325C8.78707 11.2456 10.2968 11.871 11.871 11.871V11.871Z",
    fill: "#d62828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval);
export default __webpack_public_path__ + "static/media/PendingApproval.05265641b73719f2f34cb130edb2607e.svg";
export { ForwardRef as ReactComponent };